export const FirebaseConfig = {
  apiKey: "AIzaSyDhOqyvE9BxQaFNx_u1rwCbPcZouEZuK7g",
  authDomain: "hunter-d6dda.firebaseapp.com",
  databaseURL: "https://hunter-d6dda-default-rtdb.firebaseio.com",
  projectId: "hunter-d6dda",
  storageBucket: "hunter-d6dda.appspot.com",
  messagingSenderId: "73691121412",
  appId: "1:73691121412:web:5aad6f8daf624174657251"
};
